.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.banner {
  background-color: #f8f9fa;
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 4px;
  text-align: center;
}

.content {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

.cartSection {
  margin-bottom: 30px;
}

.sectionHeader {
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.emptyCart {
  text-align: center;
  padding: 40px 0;
  color: #666;
}

.cartItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
}

.itemDetails {
  flex: 1;
}

.itemName {
  font-weight: 500;
  margin-bottom: 5px;
}

.itemPrice {
  color: #666;
}

.itemControls {
  display: flex;
  align-items: center;
}

.quantityDisplay {
  padding: 0 10px;
  min-width: 30px;
  text-align: center;
}

.actionButton {
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
}

.removeButton {
  background-color: #ff4d4f;
  color: white;
}

.cartSummary {
  margin-top: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.summaryRow {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
}

.totalRow {
  font-weight: bold;
  border-top: 1px solid #ddd;
  padding-top: 10px;
  margin-top: 10px;
}

.customerInfoSection {
  margin-top: 30px;
}

.formGroup {
  margin-bottom: 15px;
}

.formGroup label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}

.formGroup input,
.formGroup textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.formGroup textarea {
  min-height: 80px;
}

.primaryButton {
  background-color: #635BFF;
  color: white;
  border: none;
  padding: 12px 20px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  margin-top: 20px;
}

.primaryButton:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.primaryButton:hover:not(:disabled) {
  background-color: #574ce0;
}

.returnLink {
  display: block;
  margin: 20px 0;
  color: #635BFF;
  text-decoration: none;
}

.returnLink:hover {
  text-decoration: underline;
}
.specialInstructionsContainer {
  width: 100%;
  margin-top: 8px;
  margin-bottom: 12px;
}

.specialInstructionsInput {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  min-height: 40px;
  resize: vertical;
}

.specialInstructionsInput:focus {
  border-color: #635BFF;
  outline: none;
}
/* Add this at the end of the file */

.modificationIndicator {
  color: #666;
  font-size: 14px;
  font-style: italic;
  font-weight: normal;
}

.quantityControl {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 12px;
}

.quantityButton {
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  width: 30px;
  height: 30px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantity {
  min-width: 30px;
  text-align: center;
  font-weight: 500;
}